import {forwardRef, type HTMLAttributes} from 'react';

import type {CSSProperties} from 'styled-components';

import styled from 'styled-components';

import type {WithDomStyleProp, WithTestID} from '../../utils/utility-types';
import type {Props, StyledProps} from './types';

import {web} from './styles';

const StyledView = styled.div<StyledProps>`
  ${web}
`;

type ExtendedProps = WithDomStyleProp<Props> &
  WithTestID & {
    testID?: string;
  } & HTMLAttributes<HTMLDivElement> &
  CSSProperties;

type Ref = HTMLDivElement;

const View = forwardRef<Ref, ExtendedProps>((props, ref) => {
  return <StyledView ref={ref} {...props} data-test-id={props.testID} />;
});

export {View};
